import {
  REPLACE_PERMISSIONS,
  STORE_PERMISSIONS,
  INIT_PERMISSIONS,
  STORE_AVAILABLE_MODULES,
} from "../constants"

export const replacePermissions = (permissions) => ({
  type: REPLACE_PERMISSIONS,
  permissions,
})

export const initPermissions = (permissions) => {
  const availableModules = [
    ...new Set(Object.keys(permissions).map((action) => action.split(":")[0])),
  ]
  return {
    availableModules,
    type: INIT_PERMISSIONS,
  }
}

export const storePermissions = (availableModules) => ({
  availableModules,
  type: STORE_PERMISSIONS,
})
export const storeAvailableModules = (data) => ({
  availableModules: data.map(({ id }) => id),
  availableModulesData: data,
  type: STORE_AVAILABLE_MODULES,
})
